import { useMemo } from 'react';
import { getText } from 'i18n/intl';
import { keyBy } from 'lodash';

const useExportAttributes = ({
  showMembers,
  showAvailabilityRelated,
  showOptionalRelated,
  showRelations,
}: {
  showMembers: boolean;
  showAvailabilityRelated: boolean;
  showOptionalRelated: boolean;
  showRelations: boolean;
}) => {
  const attributesList = useMemo(
    () => [
      {
        label: getText('object_manager.export-modal.object.id'),
        show: true,
        value: 'id',
      },
      {
        label: getText('memberships'),
        show: showMembers,
        value: 'members',
      },
      {
        label: getText('availability_related'),
        show: showAvailabilityRelated,
        value: 'availabilityRelations',
      },
      {
        label: getText('optional_related'),
        show: showOptionalRelated,
        value: 'optionalRelations',
      },
      {
        label: getText('relations'),
        show: showRelations,
        value: 'relations',
      },
      {
        label: getText('personal_information'),
        show: true,
        value: 'personalInformation',
      },
      {
        label: getText('created'),
        show: true,
        value: 'created',
      },
      {
        label: getText('created_by'),
        show: true,
        value: 'createdBy',
      },
      {
        label: getText('active'),
        show: true,
        value: 'active',
      },
      {
        label: getText('organizations'),
        show: true,
        value: 'organizations',
      },
      {
        label: getText('virtual'),
        show: true,
        value: 'virtual',
      },
      {
        label: getText('abstract'),
        show: true,
        value: 'abstract',
      },
      {
        label: getText('template'),
        show: true,
        value: 'template',
      },
      {
        label: getText('color'),
        show: true,
        value: 'color',
      },
    ],
    [showMembers, showAvailabilityRelated, showOptionalRelated, showRelations]
  );

  const attributesMap = useMemo(() => {
    return keyBy(attributesList, (attr) => attr.value);
  }, [attributesList]);

  return useMemo(
    () => ({
      attributesList,
      attributesMap,
    }),
    [attributesList, attributesMap]
  );
};

export default useExportAttributes;
